import styled from 'styled-components'

export const StyledAnimation = styled.img`
    height: 33px;
`
